import { render } from "./AddressesList.vue?vue&type=template&id=6c8c2ab8&scoped=true&ts=true"
import script from "./AddressesList.vue?vue&type=script&lang=ts"
export * from "./AddressesList.vue?vue&type=script&lang=ts"

import "./AddressesList.vue?vue&type=style&index=0&id=6c8c2ab8&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8c2ab8"]])

export default __exports__